import React, { useCallback, useEffect, useState } from 'react';
import Pagination from './Pagination';
import { API } from '../api';
import { formatDate } from '../utils/dateUtils';
import './ClientErrorsTab.css';

const PAGE_SIZE = 20;

const ClientErrorsTab = () => {
  const [errors, setErrors] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: PAGE_SIZE, total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [userIdFilter, setUserIdFilter] = useState('');

  const loadErrors = useCallback(async (page = 1, filterValue = '') => {
    setLoading(true);
    setError('');

    try {
      const params = { page, limit: PAGE_SIZE };
      if (filterValue && Number(filterValue) > 0) {
        params.userId = Number(filterValue);
      }

      const result = await API.clientErrors.list(params);

      if (!result.success) {
        setErrors([]);
        setPagination({ page, limit: PAGE_SIZE, total: 0 });
        setError(result.error || 'Не удалось загрузить список ошибок клиента.');
        return;
      }

      const response = result.data || {};
      setErrors(Array.isArray(response.data) ? response.data : []);
      setPagination(response.pagination || { page, limit: PAGE_SIZE, total: 0 });
    } catch (e) {
      setError(e?.message || 'Не удалось загрузить список ошибок клиента.');
      setErrors([]);
      setPagination({ page, limit: PAGE_SIZE, total: 0 });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadErrors(1, '');
  }, [loadErrors]);

  const handleSubmit = (event) => {
    event.preventDefault();
    loadErrors(1, userIdFilter);
  };

  const totalPages = Math.ceil((pagination.total || 0) / (pagination.limit || PAGE_SIZE));

  return (
    <div className="tab-content client-errors">
      <section className="client-errors__panel">
        <div className="client-errors__header">
          <div>
            <h3>Ошибки клиента</h3>
            <p>Источник: /admin/client-errors?page={pagination.page}&limit={pagination.limit}</p>
          </div>
        </div>

        <form className="client-errors__toolbar" onSubmit={handleSubmit}>
          <label className="client-errors__field">
            <span>ID пользователя</span>
            <input
              type="number"
              min="1"
              value={userIdFilter}
              onChange={(event) => setUserIdFilter(event.target.value)}
              placeholder="Например: 42"
            />
          </label>

          <button type="submit" className="client-errors__submit" disabled={loading}>
            {loading ? 'Загрузка...' : 'Применить'}
          </button>
        </form>

        {error && <div className="client-errors__error">{error}</div>}

        <div className="client-errors__table-wrap">
          <table className="client-errors__table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Ошибка</th>
                <th>Сообщение</th>
                <th>Устройство</th>
                <th>URL</th>
                <th>Пользователь</th>
                <th>Создано</th>
              </tr>
            </thead>
            <tbody>
              {!loading && errors.length === 0 && (
                <tr>
                  <td colSpan="7" className="client-errors__empty">
                    Записей об ошибках клиента пока нет.
                  </td>
                </tr>
              )}

              {errors.map((errorEntry) => (
                <tr key={errorEntry.id}>
                  <td>{errorEntry.id}</td>
                  <td>
                    <div className="client-errors__stack-name">{errorEntry.name || 'UnknownError'}</div>
                    {errorEntry.stack && (
                      <pre className="client-errors__stack">{errorEntry.stack}</pre>
                    )}
                  </td>
                  <td>{errorEntry.message || '—'}</td>
                  <td>{errorEntry.device || '—'}</td>
                  <td>
                    {errorEntry.url ? (
                      <a href={errorEntry.url} target="_blank" rel="noreferrer noopener">
                        {errorEntry.url}
                      </a>
                    ) : (
                      '—'
                    )}
                  </td>
                  <td>
                    {errorEntry.user ? (
                      <div className="client-errors__user">
                        <strong>{errorEntry.user.firstName || ''} {errorEntry.user.lastName || ''}</strong>
                        <span>@{errorEntry.user.username || 'unknown'}</span>
                        <small>ID {errorEntry.user.id}</small>
                      </div>
                    ) : (
                      '—'
                    )}
                  </td>
                  <td>{formatDate(errorEntry.createdAt) || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {loading && <div className="client-errors__loading">Загрузка...</div>}

        <div className="client-errors__footer">
          <div className="client-errors__meta">Всего записей: {pagination.total || 0}</div>
          <Pagination
            currentPage={pagination.page || 1}
            totalPages={totalPages}
            onPageChange={(page) => loadErrors(page, userIdFilter)}
          />
        </div>
      </section>
    </div>
  );
};

export default ClientErrorsTab;
